import {
    Component,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    HostBinding,
    ElementRef,
    ViewChild,
    OnDestroy,
    input,
    inject,
    OnInit,
} from '@angular/core';
import { UNDERCONSTRUCTION_TITLE } from '@bazis/configuration.service';

export interface TabItem {
    id: string | number;
    title?: string;
    titleKey?: string;
    titleParams?: any;
    entityType?: string;
    routerLink?: string;
    isExactLink?: boolean;
    disabled?: boolean;
    // name иконки или src
    hasBadge?: boolean;
    icon?: string;
    iconPosition?: 'start' | 'end';
    underconstruction?: boolean;
    hidden?: boolean;
    payload?: any;
}

const sharedStylesheet = new CSSStyleSheet();
sharedStylesheet.replaceSync(
    `:host { display: contents; } :host .bazis-tab-btn-native { display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden; flex-shrink: 0; height: 100%; margin-left: var(--tab-margin-start); margin-right: var(--tab-margin-end); margin-top: var(--tab-margin-top); margin-bottom: var(--tab-margin-bottom); padding-left: var(--tab-padding-start); padding-right: var(--tab-padding-end); padding-top: var(--tab-padding-top); padding-bottom: var(--tab-padding-bottom); border-radius: var(--tab-border-radius); border-width: var(--tab-border-width); border-style: var(--tab-border-style); border-color: var(--tab-border-color); background: var(--tab-background); font-family: var(--bazis-font-family, inherit); font-size: var(--font-size); font-weight: var(--font-weight); line-height: var(--line-height); color: var(--color); outline: none; text-align: center; text-decoration: none; text-overflow: ellipsis; text-transform: inherit; white-space: nowrap; user-select: none; cursor: pointer; transition: var(--transition); } @supports (margin-inline-start: 0) or (-webkit-margin-start: 0) { :host .bazis-tab-btn-native { margin-left: unset; margin-right: unset; -webkit-margin-start: var(--tab-margin-start); margin-inline-start: var(--tab-margin-start); -webkit-margin-end: var(--tab-margin-end); margin-inline-end: var(--tab-margin-end); padding-left: unset; padding-right: unset; -webkit-padding-start: var(--tab-padding-start); padding-inline-start: var(--tab-padding-start); -webkit-padding-end: var(--tab-padding-end); padding-inline-end: var(--tab-padding-end); } } :host(.bh-underconstruction) .bazis-tab-btn-native { opacity: 0.5; cursor: not-allowed !important; } :host(.hidden) { display: none; } :host(.bazis-tab-btn--focused) .bazis-tab-btn-native, :host(:focus) .bazis-tab-btn-native, :host(:active) .bazis-tab-btn-native { background: var(--tab-background-focused); border-color: var(--tab-border-color-focused); color: var(--color-focused); } :host(:hover) .bazis-tab-btn-native { background: var(--tab-background-hover); border-color: var(--tab-border-color-hover); color: var(--color-hover); } :host(.bazis-tab-btn--selected) .bazis-tab-btn-native { background: var(--tab-background-selected); border-color: var(--tab-border-color-selected); color: var(--color-selected); font-size: var(--font-size-selected); font-weight: var(--font-weight-selected); line-height: var(--line-height-selected); } :host .bazis-tab-btn-native:disabled, :host .bazis-tab-btn-native[disabled], :host(.bazis-tab-btn--disabled) .bazis-tab-btn-native { background: var(--tab-background-disabled); border-color: var(--tab-border-color-disabled); color: var(--color-disabled); font-size: var(--font-size-disabled); font-weight: var(--font-weight-disabled); line-height: var(--line-height-disabled); cursor: default; pointer-events: none; }`,
);

@Component({
    selector: 'bazis-tab-btn',
    templateUrl: './tab-btn.component.html',
    // styleUrls: ['tab-btn.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TabBtnElement implements OnDestroy, OnInit {
    public el = inject(ElementRef);

    readonly tab = input<TabItem>();

    readonly hideByZeroCount = input(false);

    readonly selectedTab = input<string | number>(undefined);

    readonly underconstructionKey = input(UNDERCONSTRUCTION_TITLE.section);

    readonly placement = input<'base' | 'dropdown'>('base');

    tabLinkBtn;

    @ViewChild('tabLink') set tabLinkEl(el: ElementRef) {
        if (!el) return;

        this.tabLinkBtn = el.nativeElement;
    }

    @HostBinding('class') get tabStyle() {
        return {
            'bazis-tab-btn': true,
            'bh-underconstruction': this.tab().underconstruction,
            'bazis-tab-btn--selected':
                this.tab().id === this.selectedTab() ||
                (this.tab().routerLink &&
                    this.tabLinkBtn &&
                    this.tabLinkBtn.classList.contains('bazis-tab-btn--selected')),
            'bazis-tab-btn--disabled': this.tab().disabled,
            [`hidden`]: this.placement() === 'base' ? this.tab().hidden : !this.tab().hidden,
        };
    }

    ngOnDestroy() {
        this.tabLinkBtn = null;
    }

    ngOnInit(): void {
        const host = this.el.nativeElement;
        if (host && host.shadowRoot) {
            const shadowRoot = host.shadowRoot;
            const styles = shadowRoot.querySelectorAll('style');
            styles.forEach((style) => style.remove());
            shadowRoot.adoptedStyleSheets = [sharedStylesheet];
        }
    }
}
